import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button, Col } from 'reactstrap';
import { PageTitle } from '@galop/component-library';
import Can from '../Shared/Can';
import { AppName } from '../../App';
import { AssetList } from './AssetList';

export const Assets = (props) => {
    const config = {
        resourceName: 'asset',
        capitalResourceName: 'Asset',
        pluralResourceName: function () {
            return this.resourceName + 's';
        },
        pluralCapitalResourceName: function () {
            return this.capitalResourceName + 's';
        },
        listHeader: 'Name',
        writeRole: "admin",
        showHelp: true,
        controllerName: 'assets',
        localStorage: 'selected-asset'
    };
    const { CurrentUser } = props;
    const { id } = props.match.params;
    const [newResource, setNewResource] = useState(false);
    const [resourceIsDirty, setResourceIsDirty] = useState(false);
    const [updateAssets, setUpdateAssets] = useState(false);

    return (
        <div className="d-flex flex-column h-100">
            <PageTitle moduleName={config.pluralCapitalResourceName()} flexBehavior="flex-row" AppName={AppName}>
                {false && <Can role={config.writeRole}
                    yes={() =>
                        <Col className="text-right">
                            <Button color="light" className="border" onClick={() => setUpdateAssets(true)}>Update Assets</Button>
                        </Col>
                    }
                />}
            </PageTitle>
            <Can role={config.writeRole}
                yes={() =>
                    <AssetList {...{ config, updateAssets, setUpdateAssets }} CurrentUser={CurrentUser} NewResource={newResource} CloseNewResource={() => setNewResource(false)} IsDirty={(isDirty) => setResourceIsDirty(isDirty)} ShowResource={id} />
                }
                no={() => <div>Unfortunately, you don't have access to this screen. Go back to <Button tag={Link} to='/' color="secondary">Home</Button></div>}
            />
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Assets/Assets.js